export default __webpack_public_path__ + "images/ye-f62afcddf3ac8b1dfd3e9b0e67ba23bd.svg";